import axios from 'axios';
import { toast } from 'react-toastify';
import { CONTEST_LIST_SUCCESS, CONTEST_ACTIVE_SUCCESS, IS_LOADING, CONTEST_ADD_SUCCESS, CONTEST_ADD_ERROR, AUTH_LOADING, CONTEST_STATUS_CHANGED_SUCCESS, CONTEST_STATUS_CHANGED_ERROR } from './Type';
import store from "../store";
import { baseUrlPostGres } from '../constant';
import { apiHeader } from './ApiHeader';
import 'react-toastify/dist/ReactToastify.css';
import HandleError from '../HandleError';
import { apiVersion } from 'src/utils/apiVersion';

toast.configure();
export const GetContestListAction = (page, limit, senddata) => async (dispatch) => {
    dispatch({ type: IS_LOADING })
    await axios
        .get(`${baseUrlPostGres()}/admin/${apiVersion.v1}/contest/list?page=${page}&limit=${limit}&type=${senddata.type}&gtype=${senddata.gtype}`, {
            headers: apiHeader()
        })
        .then(response => {
            dispatch({
                type: CONTEST_LIST_SUCCESS,
                payload: response
            })
        })
        .catch(errors => {
            HandleError(errors.response.data)
            console.log("user list error", errors);
        })
}

export const GetAllContestAction = (body) => async (dispatch) => {
    dispatch({ type: IS_LOADING })
    await axios
        .post(`${baseUrlPostGres()}/admin/${apiVersion.v1}/poolmaster/all_active_pool_list`, body, { headers: apiHeader() })
        .then(response => {
            dispatch({ type: CONTEST_ACTIVE_SUCCESS, payload: response })
        })
        .catch(errors => {
            HandleError(errors.response.data)
            console.log("user list error", errors)
        })
}


export const ContestAddAction = (formData) => async (dispatch) => {
    dispatch({ type: IS_LOADING })
    axios
        .post(`${baseUrlPostGres()}/admin/${apiVersion.v1}/contest/create`, formData, {
            headers: apiHeader()
        })
        .then(response => {
            dispatch({
                type: CONTEST_ADD_SUCCESS,
                payload: response.data
            })
            // toast.success(response.data.message, { theme: "colored" })
        })
        .catch(errors => {
            HandleError(errors.response.data)
            dispatch({
                type: CONTEST_ADD_ERROR,
                payload: errors
            })
            // toast.error(errors.error.errorMessage.id.message, { theme: "colored" })
        })
}

export const ResetContestAddAction = () => async (dispatch) => {
    dispatch({
        type: CONTEST_ADD_SUCCESS,
        payload: {}
    })
}

export const ContestChangeStatusAction = (body) => async (dispatch) => {
    console.log("Called")
    dispatch({ type: IS_LOADING })


    await axios
        .post(`${baseUrlPostGres()}/admin/${apiVersion.v1}/contest/active-inactive`, body, {
            headers: apiHeader()
        })
        .then(response => {
            console.log("response is client register", response)
            dispatch({
                type: CONTEST_STATUS_CHANGED_SUCCESS,
                payload: response.data
            })
            toast.success(response.data.message, { theme: "colored" })

        })
        .catch(errors => {
            HandleError(errors.response.data)
            console.log("error is ", errors)
            dispatch({
                type: CONTEST_STATUS_CHANGED_ERROR,
                payload: errors
            })
            toast.error(errors.error.errorMessage.id.message, { theme: "colored" })
            console.log("error is ", errors)
        })
}

export const updateContestOrderAction = (body) => async (dispatch) => {
    console.log("Called")
    dispatch({ type: IS_LOADING })
    await axios
        .post(`${baseUrlPostGres()}/admin/${apiVersion.v1}/contest/change-contest-order`, body, {
            headers: apiHeader()
        })
        .then(response => {
            console.log("response is client register", response)
            dispatch({
                type: CONTEST_STATUS_CHANGED_SUCCESS,
                payload: response.data
            })
            toast.success(response.data.message, { theme: "colored" })

        })
        .catch(errors => {
            HandleError(errors.response.data)
            console.log("error is ", errors)
            dispatch({
                type: CONTEST_STATUS_CHANGED_ERROR,
                payload: errors
            })
            toast.error(errors.error.errorMessage.id.message, { theme: "colored" })
            console.log("error is ", errors)
        })
}